import React, { ReactHTMLElement } from 'react';

export interface CheckboxProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  checked: boolean;
  htmlFor?: string;
  label?: string | React.ReactElement;
  className?: string;
  labelClassName?: string;
}

function Checkbox({
  onChange,
  htmlFor,
  label,
  className,
  disabled,
  labelClassName,
  ...props
}: CheckboxProps) {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  return (
    <div
      className={`mb-2 checkbox-container w-max ${
        className ? ` ${className}` : ''
      }`}
    >
      <label
        className="checkbox-row font-SFProDisplay font-normal min-h-[16px]"
        htmlFor={htmlFor}
      >
        <p
          className={`pl-6 ${labelClassName ? labelClassName : ''} ${
            disabled ? ` text-gray-300 cursor-not-allowed` : ''
          }`}
        >
          {label}
        </p>
        <input
          type="checkbox"
          {...props}
          onChange={onChangeHandler}
          id={htmlFor}
          disabled={disabled}
        />
        <span className="checkmark" />
      </label>
    </div>
  );
}

export default Checkbox;
